import { useState, useEffect } from 'react';
import Text from '@/components/common/Text';
import type { NoticeFilterType } from '@/types/notices.types';
import * as S from './style';

interface NoticeFiltersProps {
  filters: NoticeFilterType;
  onFilterChange: (filters: NoticeFilterType) => void;
  onReset: () => void;
}

const NoticeFilters = ({
  filters,
  onFilterChange,
  onReset,
}: NoticeFiltersProps) => {
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleChange = (key: keyof NoticeFilterType, value: string | undefined) => {
    const newFilters = { ...localFilters, [key]: value };
    setLocalFilters(newFilters);
  };

  const handleCheckboxChange = (key: 'important' | 'is_active' | 'is_landing_popup', checked: boolean) => {
    handleChange(key, checked ? '1' : undefined);
  };

  const handleApply = () => {
    onFilterChange(localFilters);
  };

  const handleReset = () => {
    const resetFilters: NoticeFilterType = {
      important: undefined,
      is_active: undefined,
      is_landing_popup: undefined,
      platformFilter: undefined,
    };
    setLocalFilters(resetFilters);
    onReset();
  };

  return (
    <S.FilterContainer>
      <S.FilterRow>
        <S.FilterItem>
          <S.CheckboxLabel>
            <S.Checkbox
              type="checkbox"
              checked={localFilters.important === '1'}
              onChange={(e) => handleCheckboxChange('important', e.target.checked)}
            />
            <Text fontSize='0.875rem' fontWeight={600}>
              중요
            </Text>
          </S.CheckboxLabel>
        </S.FilterItem>

        <S.FilterItem>
          <S.CheckboxLabel>
            <S.Checkbox
              type="checkbox"
              checked={localFilters.is_active === '1'}
              onChange={(e) => handleCheckboxChange('is_active', e.target.checked)}
            />
            <Text fontSize='0.875rem' fontWeight={600}>
              팝업
            </Text>
          </S.CheckboxLabel>
        </S.FilterItem>

        <S.FilterItem>
          <S.CheckboxLabel>
            <S.Checkbox
              type="checkbox"
              checked={localFilters.is_landing_popup === '1'}
              onChange={(e) => handleCheckboxChange('is_landing_popup', e.target.checked)}
            />
            <Text fontSize='0.875rem' fontWeight={600}>
              랜딩
            </Text>
          </S.CheckboxLabel>
        </S.FilterItem>

        <S.FilterItem>
          <Text fontSize='0.875rem' fontWeight={600}>
            플랫폼:
          </Text>
          <S.Select
            value={localFilters.platformFilter ?? 'all'}
            onChange={(e) =>
              handleChange(
                'platformFilter',
                e.target.value === 'all' ? undefined : (e.target.value as 'web' | 'app' | 'common')
              )
            }
          >
            <option value='all'>전체</option>
            <option value='web'>웹</option>
            <option value='app'>앱</option>
            <option value='common'>웹+앱</option>
          </S.Select>
        </S.FilterItem>

        <S.ButtonContainer>
          <S.Button onClick={handleApply}>적용</S.Button>
          <S.Button onClick={handleReset}>초기화</S.Button>
        </S.ButtonContainer>
      </S.FilterRow>
    </S.FilterContainer>
  );
};

export default NoticeFilters;
